import React, { FunctionComponent, memo, useCallback, useMemo } from 'react'
import styles from './Participants.module.sass'
import { User, UserWithDepartments } from '../../../../../responses/users'
import { useRootDispatch } from '../../../../../utils/hooks'
import { projectDetailActions } from '../../../../../redux/pages/project-detail'
import { Project } from '../../../../../responses/projects'
import Participant, { SubscribedUser } from './Participant'
import { pipe } from 'fp-ts/es6/pipeable'
import { map, sort } from 'fp-ts/es6/Array'
import { groupBy } from 'fp-ts/es6/NonEmptyArray'
import { toArray } from 'fp-ts/es6/Record'
import { fromCompare, ordString } from 'fp-ts/es6/Ord'
import clsx from 'clsx'
import Group from '../../../../etc/Group/Group'
import Aside from '../../../../etc/Aside/Aside'

interface Props {
    className?: string,
    project: Project,
}

const ord = fromCompare<[string, SubscribedUser[]]>((x, y) => ordString.compare(x[0], y[0]))

const Participants: FunctionComponent<Props> = props => {
    const dispatch = useRootDispatch()

    const departments = useMemo(() => {
        return pipe(
            props.project.users,
            map((user: UserWithDepartments) => ({
                ...user,
                subscribed: !props.project.unsubscribed_users.find(id => id == user.id)
            })),
            groupBy((user: SubscribedUser) => user.departments?.[0]?.title || 'Без отдела'),
            toArray,
            sort(ord)
        )
    }, [props.project.users, props.project.unsubscribed_users])

    const manager: SubscribedUser = useMemo(() => ({
        ...props.project.manager,
        subscribed: !props.project.unsubscribed_users.find(id => id == props.project.manager.id)
    }), [props.project.manager, props.project.unsubscribed_users])

    const subscribe = useCallback((user: User) => dispatch(projectDetailActions.subscribe.request({
        userId: user.id,
        projectId: props.project.id,
    })), [dispatch, props.project.id])

    const unsubscribe = useCallback((user: User) => dispatch(projectDetailActions.unsubscribe.request({
        userId: user.id,
        projectId: props.project.id,
    })), [dispatch, props.project.id])

    return <Aside className={clsx(props.className, styles.participants)}>
        <div className={styles.header}>Менеджер проекта</div>
        <Participant
            className={styles.manager}
            user={manager}
            onSubscribe={subscribe}
            onUnsubscribe={unsubscribe}
        />
        <div className={styles.header}>Участники</div>
        {
            departments.map(([department, users]) => <div
                key={department}
                className={styles.group}
            >
                <Group headerHeight={18} header={<div>{department}</div>}>
                {
                    users.map(user => <Participant
                        key={user.id}
                        user={user}
                        onSubscribe={subscribe}
                        onUnsubscribe={unsubscribe}
                    />)
                }
                </Group>
            </div>)
        }
    </Aside>
}

export default memo(Participants)